import React, { forwardRef } from 'react'
import CustomTextField from 'components/Form/CustomTextField'
import { Box } from '@mui/material'

const PhoneInput = (props, ref) => {
  return (
    <Box width="100%" sx={style.input}>
      <CustomTextField {...props} inputRef={ref} fullWidth variant="outlined" name="phone" />
    </Box>
  )
}
export default forwardRef(PhoneInput)

const style = {
  input: {
    '.MuiFormControl-root ': {
      display: 'block'
    }
  }
}
